import { useRouter } from '@funtech-int/rival-react';
import { useCallback } from 'react';

import { useSearchParams } from '@/shared/hooks/useSearchParams';

import { MultiOfferTab, isMultiOfferTab } from '../lib/offers';
import { mainRoute } from '../routes';

export const useMultiOfferTab = () => {
    const router = useRouter();
    const searchParams = useSearchParams();
    const paywallOfferTab = searchParams.get('paywallOfferTab');

    const setMultiOfferTab = useCallback(
        (tabId: MultiOfferTab) => {
            if (tabId === paywallOfferTab) {
                return;
            }

            const newSearchParams = new URLSearchParams(searchParams);
            newSearchParams.set('paywallOfferTab', tabId);

            router.navigate({
                to: mainRoute(),
                replace: true,
                meta: {
                    searchParams: newSearchParams,
                },
            });
        },
        [paywallOfferTab, searchParams, router]
    );

    return {
        tabId: isMultiOfferTab(paywallOfferTab) ? paywallOfferTab : 'base',
        setMultiOfferTab,
    };
};
